import React, { useEffect, useState, useContext } from "react";
import { useHistory, useLocation } from "react-router-dom";
import logo from "../../assets/LargeLogo_new.png";
import { BiMenuAltRight, BiHomeAlt } from "react-icons/bi";
import { IoMdLogOut } from "react-icons/io";
import { MdArrowBack } from "react-icons/md";
import { HiMenu } from "react-icons/hi";
import { gql, useLazyQuery } from "@apollo/client";
import { useMsal } from "@azure/msal-react";

import {
  ProSidebar,
  Menu,
  MenuItem,
  SubMenu,
  SidebarHeader,
  SidebarFooter,
  SidebarContent,
} from "react-pro-sidebar";
// import "react-pro-sidebar/dist/css/styles.css";
import "./Dashboard.scss";

const Sidenav = ({ ...props }) => {
  const { instance } = useMsal();
  const [closeBar, setCloseBar] = useState(true);
  const [id_token, setToken] = useState("");
  const [isOnline, setNetwork] = useState(window.navigator.onLine);
  const [pathHistory, setPathHistory] = useState([]);
  const location = useLocation();
  const history = useHistory();

  useEffect(() => {
    // Add the current path to the history list whenever the location changes
    setPathHistory((prevPaths) => [
      ...prevPaths,
      location.pathname + (location.search ? location.search : "")
    ]);
  }, [location]);
  useEffect(() => {}, [props.bgColor]);
  useEffect(() => {
    window.addEventListener("offline", updateNetwork);
    window.addEventListener("online", updateNetwork);
    return () => {
      window.removeEventListener("offline", updateNetwork);
      window.removeEventListener("online", updateNetwork);
    };
  }, []);
  const updateNetwork = () => {
    setNetwork(window.navigator.onLine);
  };
  const goBack = () => {
    const dedupedHistory = pathHistory.filter(
      (path, idx, arr) => idx === 0 || path !== arr[idx - 1]
    );
    if (dedupedHistory.length > 1) {
      // Go to the previous path in your custom history
      const previousPath = dedupedHistory[dedupedHistory.length - 2];
      history.push(previousPath);
      // Update pathHistory to remove the last entry and adjacent duplicates
      setPathHistory(dedupedHistory.slice(0, -1));
    } else {
      // Fallback to a default route
      history.push("/customers");
    }
  };
  /* istanbul ignore next */
  const userLogout = () => {
    if (isOnline) {
      if (window.self !== window.top) {
        instance
          .logoutPopup({
            postLogoutRedirectUri: "/",
          })
          .then(() => {
            history.push("/");
          });
      } else {
        instance.logoutRedirect({
          postLogoutRedirectUri: "/",
        });
      }
    } else {
      history.push("/");
    }
  };
  /* istanbul ignore next */
  const toCustomers = () => {
    if (localStorage.getItem("singleCustomer") == "false") {
      history.push("/customers");
    } else {
      history.push(localStorage.getItem("vesselHome"));
    }
    setCloseBar(true);
  };
  /* istanbul ignore next */
  const BackButton = () => {
    if (localStorage.getItem("singleCustomer") == "true") {
      if (window.location.hash !== "#" + localStorage.getItem("vesselHome")) {
        return (
          <span
            data-testif="backy"
            onClick={() => goBack()}
            className="backIcon"
            style={{ color: props.bgColor }}
          >
            <MdArrowBack />
          </span>
        );
      } else {
        return null;
      }
    } else {
      if (window.location.hash !== "#/customers") {
        return (
          <span
            onClick={() => goBack()}
            className="backIcon"
            style={{ color: props.bgColor }}
          >
            <MdArrowBack />
          </span>
        );
      } else {
        return null;
      }
    }
  };
  return (
    <>
      <BackButton />

      <span
        onClick={() => setCloseBar(false)}
        className="menuIcon"
        data-testif="menuBtn"
        style={{ color: props.bgColor }}
      >
        <HiMenu />
      </span>
      {!closeBar ? (
        <div className="modal-window" onClick={() => setCloseBar(true)}></div>
      ) : null}
      <ProSidebar
        collapsed={closeBar}
        collapsedWidth={"0px"}
        className="right-bar"
      >
        <SidebarHeader className="right-bar-head">
          <div className="head">
            <img className="logo" src={logo} alt="logo" />
            <h1 className="title">Reporter</h1>
          </div>
        </SidebarHeader>
        <hr />
        <SidebarContent>
          <Menu className="menu">
            <MenuItem
              icon={<BiHomeAlt className="icon" />}
              onClick={toCustomers}
            >
              Home
            </MenuItem>

            <MenuItem
              icon={<IoMdLogOut className="icon" />}
              onClick={userLogout}
            >
              Logout
            </MenuItem>
          </Menu>
        </SidebarContent>
      </ProSidebar>
    </>
  );
};

export default Sidenav;
